exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".form-readonly[data-v-94968dca]{color:#606266}", "", {"version":3,"sources":["/workspace/src/views/order-review-target-management/components/TargetSettingFormDialog.vue"],"names":[],"mappings":"AACA,gCAAgC,aAAa,CAC5C","file":"TargetSettingFormDialog.vue","sourcesContent":["\n.form-readonly[data-v-94968dca]{color:#606266\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-94968dca","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/order-review-target-management/components/TargetSettingFormDialog.vue
// module id = 4658
// module chunks = 142